// src/config/emailjs-config.js
// Direct configuration - no environment variables needed

export const EMAILJS_CONFIG = {
  SERVICE_ID: 'service_i8vfuac',
  TEMPLATE_FORMS: 'template_p8tpsfl', 
  TEMPLATE_DONATION: 'template_2v672mt',
  PUBLIC_KEY: 'tpXSz1-_leAFrCNv7',
  ORGANIZATION_EMAIL: 'info@essentialmom.net'
};

export default EMAILJS_CONFIG;